import log from '@/logger'
import store from '@/store'

export default (error) => {
  if (error.response) {
    log.error('API - ERROR', error.response.status, error.response.config.url)
    store.dispatch('app/onError', error)
  } else if (error.request) {
    log.error('The request was made but no response was received')
  } else {
    log.error('Something happened in setting up the request that triggered an error')
  }
  return Promise.reject(error)
}



// WEBPACK FOOTER //
// ./src/services/interceptors/response-error.js